import { Component, h, tag } from "omi";

import { animateCss } from "@/globals/styles";
import { networkSignal } from "@/utils/signals";
import { NWButton, NWError } from "@/components";
import { tailwind } from "@/tailwind";
import { initApi } from "@/utils";

import { ModalProps } from "../../models";

export type ProjectUpdateModalProps = {
  projectId: string;
};

type Props = ModalProps<ProjectUpdateModalProps>;

@tag("nw-project-update-modal")
export class ProjectUpdateModal extends Component<Props> {
  static css = [tailwind, animateCss];
  private updateSignal = networkSignal({ retry: { delayMs: 1000, maxAttempts: 3 } });

  private handleOnSubmit = async () => {
    const api = initApi();
    const res = await this.updateSignal.run(async () => {
      await api.resetProjectContent({ id: this.props.data.projectId });
      return true;
    });

    if (res) {
      this.props.close();
    }
  };

  render() {
    return (
      <div class="bg-white rounded-xl text max-w-lg w-full max-h-3/4 z-[100]">
        <div class="content flex flex-col">
          <div class="body p-6">
            <div class="px-5 py-2">
              <h3 class="font-bold text-center text-xl">This project has new upgrades! 🎉</h3>
            </div>

            <div class="space-y-4 mt-3 text-secondary px-2">
              <p>We’ve been hard at work adding new content to this project. 🎉</p>
              <p>
                Just a quick heads-up: your highlights and notes will be lost. But don’t worry—your validations and
                documentation are safe and sound!
              </p>
            </div>
            <div class="pt-8">
              <NWButton
                type="primary"
                size="full"
                onClick={this.handleOnSubmit}
                loading={this.updateSignal.signal.isLoading.value}
              >
                Update my project!
              </NWButton>
            </div>
            {this.updateSignal.signal.error.value != null && (
              <div class="pt-2">
                <NWError></NWError>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
